import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';
import axiosInstance from './instance.js';

var i18n;

export const SUPPORT_LOCALES = ['en', 'ru', 'kz'];

export function setI18nLanguage(locale) {
  loadLocaleMessages(locale);

  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }

  document.querySelector('html').setAttribute('lang', locale);
  localStorage.setItem('lang', locale);

}

export async function loadLocaleMessages(locale) {
  let staticMessages = {};
  let apiMessages = {};

  try {
    const messages = await import(`@/langs/${locale}.json`);
    staticMessages = messages.default || {};
  } catch (e) {
    console.warn("JSON Translations have not downloaded", e);
  }

  try {
    const endpoints = [
      '/api/home',
      '/api/about',
      '/api/services',
      '/api/projects',
      '/api/products',
      '/api/categories',
      '/api/news',
      '/api/contacts',
    ];

    const responses = await Promise.all(
      endpoints.map((url) =>
        axiosInstance
          .get(url, { headers: { 'Accept-Language': locale } })
          .catch(() => null)
      )
    );

    responses.forEach((res) => {
      if (res && res.data) {
        const key = res.config.url.replace('/api/', '');
        apiMessages[key] = res.data;
      }
    });
  } catch (e) {
    console.warn("API error:", e);
  }

  i18n.global.setLocaleMessage(locale, {
    ...staticMessages,
    api: apiMessages
  });

  return nextTick();
}

export default function setupI18n() {
  if (!i18n) {
    let locale = localStorage.getItem('lang') || 'ru';

    i18n = createI18n({
      globalInjection: true,
      legacy: false,
      locale: locale,
      fallbackLocale: 'ru'
    });

    setI18nLanguage(locale);
  }
  return i18n;
}
